'use client';

import { Button, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { useMedalliaFeedback } from '@libs/common-next';

import { FeedbackSkeleton } from './feedback-skeleton';

import './feedback-button.scss';

const TEXT = {
    error: 'Feedback is unavailable right now. Please try again later.',
    default: 'Help us improve your PetSmart experience.',
};

export function FeedbackButton() {
    const { formState, onOpen } = useMedalliaFeedback();

    if (formState === 'blocked') return null;
    if (formState === 'loading') return <FeedbackSkeleton />;

    return (
        <div className={cn('feedback-button', { 'feedback-button--error': formState === 'error' })}>
            <TextPassage className="feedback-button__text" size="lg">
                {formState === 'error' ? TEXT.error : TEXT.default}
            </TextPassage>

            <Button text="Give feedback" disabled={formState === 'error'} onClick={onOpen} />
        </div>
    );
}
